import produce from 'immer';

import {
  LOAD_REPORT_REQUEST,
  LOAD_REPORT_SUCCESS,
  LOAD_REPORT_FAILURE,
  UPDATE_TICKET_DEPARTMENT_REQUEST,
  UPDATE_TICKET_DEPARTMENT_SUCCESS,
  UPDATE_TICKET_DEPARTMENT_FAILURE,
} from './constants';

const initialState = {
  loading: true,
  error: '',
  success: false,
  report: {},
  updatedTicket: {},
};

export default function reportReducer(baseState = initialState, action) {
  return produce(baseState, (state) => {
    switch (action.type) {
      case LOAD_REPORT_REQUEST:
        state.loading = true;
        state.error = '';
        state.success = false;
        state.report = {};
        break;
      case LOAD_REPORT_SUCCESS:
        state.loading = false;
        state.error = '';
        state.success = true;
        state.report = action.data;
        break;
      case LOAD_REPORT_FAILURE:
        state.loading = false;
        state.error = action.error;
        state.success = false;
        state.report = {};
        break;
      case UPDATE_TICKET_DEPARTMENT_REQUEST:
        state.loading = true;
        state.error = '';
        state.success = false;
        state.updatedTicket = {};
        break;
      case UPDATE_TICKET_DEPARTMENT_SUCCESS:
        state.loading = false;
        state.error = '';
        state.success = true;
        state.updatedTicket = action.data;
        state.report.ticket = action.data;
        break;
      case UPDATE_TICKET_DEPARTMENT_FAILURE:
        state.loading = false;
        state.error = action.error;
        state.success = false;
        state.updatedTicket = {};
        break;
      default:
        break;
    }
  });
}
